
import React from 'react';
import MetauxNonFerreuxDepartments from './sections/MetauxNonFerreuxDepartments';
import MetauxNonFerreuxCities from './sections/MetauxNonFerreuxCities';
import MetauxNonFerreuxTypes from './sections/MetauxNonFerreuxTypes';

const MetauxNonFerreuxSEO = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 mt-16">
      <MetauxNonFerreuxDepartments />
      <MetauxNonFerreuxCities />
      <MetauxNonFerreuxTypes />
    </div>
  );
};

export default MetauxNonFerreuxSEO;
